import initialState from './initialState';

export function supplierItemsHasErrored(
  state = initialState.supplierItemsHasErrored,
  action,
) {
  switch (action.type) {
    case 'SUPPLIER_ITEMS_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}
export function supplierItemsIsLoading(
  state = initialState.supplierItemsIsLoading,
  action,
) {
  switch (action.type) {
    case 'SUPPLIER_ITEMS_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}
export function supplierItems(state = initialState.supplierItems, action) {
  switch (action.type) {
    case 'SUPPLIER_ITEMS_FETCH_DATA_SUCCESS':
      return action.items;
    case 'CLEAR_SUPPLIER_LIST_DATA':
      return [];
    default:
      return state;
  }
}

export function supplierItemHasErrored(
  state = initialState.supplierItemHasErrored,
  action,
) {
  switch (action.type) {
    case 'SUPPLIER_ITEM_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}
export function supplierItemIsLoading(
  state = initialState.supplierItemIsLoading,
  action,
) {
  switch (action.type) {
    case 'SUPPLIER_ITEMS_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}
export function supplierItem(state = initialState.supplierItem, action) {
  switch (action.type) {
    case 'SUPPLIER_ITEM_FETCH_DATA_SUCCESS':
      return action.item;
    default:
      return state;
  }
}

export function purchaseRebateSupplierItemsHasErrored(
  state = initialState.purchaseRebateSupplierItemsHasErrored,
  action,
) {
  switch (action.type) {
    case 'PURCHASE_REBATE_SUPPLIER_ITEMS_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}
export function purchaseRebateSupplierItemsIsLoading(
  state = initialState.purchaseRebateSupplierItemsIsLoading,
  action,
) {
  switch (action.type) {
    case 'PURCHASE_REBATE_SUPPLIER_ITEMS_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}
export function purchaseRebateSupplierItems(
  state = initialState.purchaseRebateSupplierItems,
  action,
) {
  switch (action.type) {
    case 'PURCHASE_REBATE_SUPPLIER_ITEMS_FETCH_DATA_SUCCESS':
      return action.items;
    default:
      return state;
  }
}

export function purchaseRebateSupplierItemHasErrored(
  state = initialState.purchaseRebateSupplierItemHasErrored,
  action,
) {
  switch (action.type) {
    case 'PURCHASE_REBATE_SUPPLIER_ITEM_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}
export function purchaseRebateSupplierItemIsLoading(
  state = initialState.purchaseRebateSupplierItemIsLoading,
  action,
) {
  switch (action.type) {
    case 'PURCHASE_REBATE_SUPPLIER_ITEMS_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}
export function purchaseRebateSupplierItem(
  state = initialState.purchaseRebateSupplierItem,
  action,
) {
  switch (action.type) {
    case 'PURCHASE_REBATE_SUPPLIER_ITEM_FETCH_DATA_SUCCESS':
      return action.item;
    default:
      return state;
  }
}

export function isNewPurchaseRebateSupplierSaveSuccess(
  state = initialState.isNewPurchaseRebateSupplierSaveSuccess,
  action,
) {
  switch (action.type) {
    case 'PURCHASE_REBATE_SUPPLIER_SAVE_SUCCESS':
      return {
        isSavedSuccess: action.isSaved,
        supplier: action.supplier,
      };
    default:
      return state;
  }
}

export function isNewPurchaseRebateSupplierSaveErrored(
  state = initialState.isNewPurchaseRebateSupplierSaveErrored,
  action,
) {
  switch (action.type) {
    case 'PURCHASE_REBATE_SUPPLIER_SAVE_ERRORED':
      return {
        isSaveErrored: action.hasErrored,
        message: action.message,
      };
    default:
      return state;
  }
}

export function isNewPurchaseRebateSupplierIsSaving(
  state = initialState.isNewPurchaseRebateSupplierIsSaving,
  action,
) {
  switch (action.type) {
    case 'PURCHASE_REBATE_SUPPLIER_IS_SAVING':
      return action.isSaving;
    default:
      return state;
  }
}

export function isNewPurchaseRebateSupplierRemoveSuccess(
  state = initialState.isNewPurchaseRebateSupplierRemoveSuccess,
  action,
) {
  switch (action.type) {
    case 'PURCHASE_REBATE_SUPPLIER_REMOVE_SUCCESS':
      return {
        isRemovedSuccess: action.isRemoving,
        supplier: action.supplier,
      };
    default:
      return state;
  }
}

export function isNewPurchaseRebateSupplierRemoveErrored(
  state = initialState.isNewPurchaseRebateSupplierRemoveErrored,
  action,
) {
  switch (action.type) {
    case 'PURCHASE_REBATE_SUPPLIER_REMOVE_ERRORED':
      return {
        isRemoveErrored: action.isRemoveErrored,
        message: action.message,
      };
    default:
      return state;
  }
}

export function isNewPurchaseRebateSupplierIsRemoving(
  state = initialState.isNewPurchaseRebateSupplierIsRemoving,
  action,
) {
  switch (action.type) {
    case 'PURCHASE_REBATE_SUPPLIER_IS_REMOVING':
      return action.isRemoving;
    default:
      return state;
  }
}
